import Http from './http';
import store from 'store';
import JurisdictionService from './jurisdiction';
import RegulatorsService from './regulators';
import DocumentTypesService from './documentTypes';
import ServiceLinesService from './serviceLines';
import RegCatsService from './regCats';
import SavedSearchService from './savedSearch';

class TaxonomyService {
    constructor() {
        this.taxonomy = null;
        this.updatedTimestamp = new Date().getTime();
        this.ModelName = '';
    }
    
    init() {
        //setInterval(()=> this.resetCache(), 60010);
    }
    
    resetCache(){
        store.set('taxonomy', false)
        this.taxonomy = null;
        this.getTaxonomy()
    }

    resetTaxonomyMappedEntities(){
        JurisdictionService.resetCache();
        RegulatorsService.resetCache();
        DocumentTypesService.resetCache();
        ServiceLinesService.resetCache();
        RegCatsService.resetCache();
        SavedSearchService.resetCache();
    }

    checkTaxonomy(modelName, updatedAt){
        const container = document.getElementById('modelNameBreadcrumb');
        if (modelName == 'Global'){
            if (container) container.innerText = 'Corlytics Global View';
            store.set('modelName', 'Corlytics Global View');
        }else{
            store.set('modelName', modelName)
            if (container) container.innerText = store.get('modelName')
        }
        const name = modelName === 'Global' ? 'Corlytics Global View' : modelName;

        if (name !== store.get('modelName') || parseInt(updatedAt) > this.updatedTimestamp){
            this.updatedTimestamp = parseInt(updatedAt)
            this.resetTaxonomyMappedEntities();
        }
        this.ModelName = store.get('modelName')
    }

    getTaxonomy() {
        //return
        return new Promise((resolve, reject) => {

            if (store.get('taxonomy', false)){
                this.taxonomy = store.get('modelName');
            }
            if (this.taxonomy) resolve(this.taxonomy);
            else {
                Http.get('/taxonomy/available-models/').then(resp => {
                    this.taxonomy = 1
                    let empty = true;
                    let activeModels = []
                    const container = document.getElementById('modelNameBreadcrumb');
                    store.set('activeModels', resp.data.data);
                    for (let idx in resp.data.data) {
                        if (resp.data.data[idx].isDefault) {
                            empty = false;
                            activeModels.push(resp.data.data[idx].modelName)
                        }
                    }
                    const modelName = activeModels.length? activeModels.join(', ') : 'Global'

                    this.checkTaxonomy(modelName, new Date().getTime())
                    // if (empty){
                    //     container.innerText = 'Corlytics Global View';
                    //     store.set('modelName', 'Corlytics Global View');
                    // }else{
                    //     store.set('modelName', activeModels.join(', '))
                    //     container.innerText = store.get('modelName')
                    // }
                    // if (this.ModelName !== store.get('modelName')){
                    //     //this.resetTaxonomyMappedEntities();
                    // }
                    // this.ModelName = store.get('modelName')
                    resolve(this.taxonomy)
                });
            }
        })
    }
}

export default new TaxonomyService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/taxonomy.js